import { useMemo } from 'react';
import CallActions from './CallActions';
import { Room } from '../../../models/room';
import { BASIC_CALL_ACTIONS } from './callActions.constants';
import { handlePopulateActionButtons } from './callActions.helper';

const CallActionsContainer = (props) =>{

    const { type = "", handleToggleActiveButtonActions, handleSetActiveState, handleUpdateActiveToken, handleClearFrame, ...rest } = props;

    // Use the manually connected room singleton — not the LiveKitRoom context room
    // (which is unconnected since we use connect={false} on <LiveKitRoom>)
    const roomInstance = Room.getInstance().getRoomInstance();

    const activeButton = useMemo(()=>{
        return BASIC_CALL_ACTIONS[type][rest.enabled ? 'true' : 'false'];
    },[type, rest.enabled]);

    const formattedActionButtons = useMemo(()=>{
        return handlePopulateActionButtons(activeButton, roomInstance, handleToggleActiveButtonActions, rest.enabled, handleSetActiveState, handleUpdateActiveToken, handleClearFrame);
    },[activeButton, roomInstance, handleToggleActiveButtonActions, rest.enabled, handleSetActiveState,handleUpdateActiveToken, handleClearFrame]);

    if (!roomInstance) {
        return null;
    }

    return (
        <CallActions {...rest} activeButton={formattedActionButtons}/>
    )
}

export default CallActionsContainer;